// import { CssBaseline, ThemeProvider } from '@mui/material';
import { CssBaseline, ThemeProvider } from '@mui/material';

import { Toaster } from 'react-hot-toast';
import { useRoutes } from 'react-router-dom';
// import SettingsDrawer from "./components/ui/SettingsDrawer";
import routes from './routes';
import useSettings from './hooks/useSettings';
import { createCustomTheme } from './theme';
import RTL from './components/ui/RTL';

import './i18n/i18n';
// import useScrollReset from './hooks/useScrollReset';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { initialize, initializePetroHub } from './store/actions/authActions';
import AppCookieConsent from './AppCookieConsent';

function App() {
  const dispatch = useDispatch();
  const content = useRoutes(routes);
  const domain = window.location.hostname;
  const isPetroHub = domain.toLocaleLowerCase().includes('petrohub') || domain.toLocaleLowerCase().includes('localhost');

  const { settings } = useSettings();
  const theme = createCustomTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme,
  });

  useEffect(() => {
    if (isPetroHub) {
      dispatch(initializePetroHub());
    } else {
      dispatch(initialize());
    }
  }, [dispatch, isPetroHub]);

  return (
    <ThemeProvider theme={theme}>
      <RTL direction={settings.direction}>
        <CssBaseline />
        <Toaster position="top-center" />
        {/* <SettingsDrawer /> */}
        {content}
        <AppCookieConsent />
      </RTL>
    </ThemeProvider>
  );
}

export default App;
